/**
 * @generated SignedSource<<af49930390e2100282e6e231ac571011>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceSignalEditMainProductsUnLinkMutation$variables = {
  productId: string;
  signalWorkspaceId: string;
};
export type WorkspaceSignalEditMainProductsUnLinkMutation$data = {
  readonly signalWorkspace: {
    readonly unlinkProduct: {
      readonly id: string;
      readonly linkedProducts: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  };
};
export type WorkspaceSignalEditMainProductsUnLinkMutation = {
  response: WorkspaceSignalEditMainProductsUnLinkMutation$data;
  variables: WorkspaceSignalEditMainProductsUnLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "signalWorkspaceId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "signalWorkspaceId"
      }
    ],
    "concreteType": "SignalWorkspaceMutation",
    "kind": "LinkedField",
    "name": "signalWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "productId",
            "variableName": "productId"
          }
        ],
        "concreteType": "SignalWorkspace",
        "kind": "LinkedField",
        "name": "unlinkProduct",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "WorkspaceProduct",
            "kind": "LinkedField",
            "name": "linkedProducts",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalEditMainProductsUnLinkMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalEditMainProductsUnLinkMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "aad7667e00c9493e2ba76af96fc43399",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalEditMainProductsUnLinkMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalEditMainProductsUnLinkMutation(\n  $productId: ID!\n  $signalWorkspaceId: ID!\n) {\n  signalWorkspace(id: $signalWorkspaceId) {\n    unlinkProduct(productId: $productId) {\n      id\n      linkedProducts {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "de9bc49b401918e0532c518d6e60bf7e";

export default node;
